import React from 'react'

const RoleContext = React.createContext({
    characterrole: ''
})

export default RoleContext